export default __webpack_public_path__ + "static/media/benefit4.5852bd47.png";